import React from "react";
import { useCookies } from "react-cookie";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const [cookies] = useCookies(["reebukToken"]);

  return cookies.reebukToken ? <Outlet /> : <Navigate to="/auth/Login" />;
};

export default ProtectedRoute;
